'use client';

// B 端 token
export const getBToken = () => {
    return localStorage.getItem('bh-token');
};
// B 端 token
export const setBToken = (token: string) => {
    if (token) {
        return localStorage.setItem('bh-token', token);
    }
};
// C 端 token
export const getCToken = () => {
    return localStorage.getItem('token');
};
// C 端 token
export const setCToken = (token: string) => {
    if (token) {
        return localStorage.setItem('token', token);
    }
};
